import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

export class SwichToogle extends React.Component {
    constructor(props) {
        super(props);
        this.handleCheckChanged = this.handleCheckChanged.bind(this);
    }

    static propTypes = {
        title: PropTypes.string,
        value: PropTypes.bool,
    };

    handleCheckChanged(e) {
        this.props.onCheckChanged(this.props.name, e.target.checked);
    }

    render() {
        return (
            <StyledWrapper>
                <label className="toggle-switch">
                    <input
                        type="checkbox"
                        id={this.props.name}
                        checked={this.props.value}
                        onClick={(e) => {
                            this.handleCheckChanged(e);
                        }}
                    />
                    <div className="toggle-switch-background">
                        <div className="toggle-switch-handle" />
                    </div>
                </label>
            </StyledWrapper>
        );
    }
}

const StyledWrapper = styled.div`
    display: inline-block;
    height: 24px;

    label.toggle-switch {
        margin-bottom: 0;
    }

    .toggle-switch {
        position: relative;
        display: inline-block;
        width: 46px;
        height: 24px;
        cursor: pointer;
    }

    .toggle-switch input[type="checkbox"] {
        display: none;
    }

    .toggle-switch-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #ddd;
        border-radius: 12px;
        box-shadow: inset 0 0 0 2px #ccc;
        transition: background-color 0.3s ease-in-out;
    }

    .toggle-switch-handle {
        position: absolute;
        top: 2px;
        left: 2px;
        width: 20px;
        height: 20px;
        background-color: #fff;
        border-radius: 50%;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        transition: transform 0.3s ease-in-out;
    }

    .toggle-switch::before {
        content: "";
        position: absolute;
        top: -25px;
        right: -35px;
        font-size: 12px;
        font-weight: bold;
        color: #aaa;
        text-shadow: 1px 1px #fff;
        transition: color 0.3s ease-in-out;
    }

    .toggle-switch input[type="checkbox"]:checked + .toggle-switch-handle {
        transform: translateX(22px);
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2), 0 0 0 3px #05c46b;
    }

    .toggle-switch input[type="checkbox"]:checked + .toggle-switch-background {
        background-color: #05c46b;
        box-shadow: inset 0 0 0 2px #04b360;
    }

    .toggle-switch input[type="checkbox"]:checked + .toggle-switch:before {
        content: "On";
        color: #05c46b;
        right: -15px;
    }

    .toggle-switch input[type="checkbox"]:checked + .toggle-switch-background .toggle-switch-handle {
        transform: translateX(22px);
    }
`;
